// extracted by mini-css-extract-plugin
export var productMobile = "product-module--product-mobile--94bb2";
export var productPc = "product-module--product-pc--1c8e7";